import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import store from "@/store";
import i18n from "@/i18n";
import { Lenguages } from "../helpers/Lenguages";

/* Middleware */
import guest from "@/middleware/guest";
import auth from "@/middleware/auth";

/* Rutas */
import Inicio from "../views/Inicio/components";
import Login from "../views/Login/components";
import NotFound from "@/views/NotFound/components";
import SeleccionCliente from "@/views/Ventas/SeleccionCliente/components";
import Ventas from "@/views/Ventas/component";
import Venta from "@/views/Ventas/Venta/component";
import Historico from "@/views/Ventas/Historico/component";
import PedidoCompletados from "@/views/Ventas/PedidoCompletados/component";
import FinalizarPedido from "@/views/FinalizarPedido/component";
import FacturasPdf from "@/views/Ventas/FacturasPdf/component";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    redirect: `/${i18n.locale}`,
  },
  {
    path: "/:lang",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "",
        redirect: {
          name: "Login",
          params: {
            lang: i18n.locale,
          },
        }
      },
      {
        path: "FinalizarPedido",
        name: "FinalizarPedido",
        component: FinalizarPedido,
        meta: {
          middleware: [auth],
        }, 
      },     
      {
        path: "inicio",
        name: "Inicio",
        component: Inicio,
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "Ventas",
        name: "Ventas",
        component: Ventas,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "seleccioncliente",
            name: "SeleccionCliente",
            component: SeleccionCliente,
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "venta",
            name: "venta",
            component: Venta,
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "Historico",
            name: "Historico",
            component: Historico,
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "PedidoCompletados",
            name: "PedidoCompletados",
            component: PedidoCompletados,
            meta: {
              middleware: [auth],
            },
          },
          {
            path: "FacturasPdf",
            name: "FacturasPdf",
            component: FacturasPdf,
            meta: {
              middleware: [auth],
            },
          }
        ]
      },
      {
        path: "login",
        name: "Login",
        component: Login,
        meta: {
          middleware: [guest],
        },
      },
      {
        path: "notfound",
        name: "NotFound",
        component: NotFound,
      },
    ],
  },
  {
    path: "*",
    redirect: {
      name: "NotFound",
      params: {
        lang: i18n.locale,
      },
    },
  },
];

const router = new VueRouter({
  mode: "history",
  /* linkExactActiveClass: "is-active", */
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  let lenguage: string = to.params.lang;

  const existe = Object.values(Lenguages).filter((x) => x == lenguage).length;

  if (!lenguage || !existe) {
    lenguage = store.state.lang;
  }
  i18n.locale = lenguage;

  //Resetear password
  //@ts-ignore
  // if (store.state.auth.usuario.resetearPassword) {
  //   next({ name: "ResetearPassword", params: { lang: i18n.locale } });
  // }

  if (!to.meta.middleware) {
    next();
  } else {
    const middleware = to.meta.middleware;

    const context = {
      to,
      from,
      next,
      store,
      i18n,
    };

    return middleware[0]({ ...context });
  }
});

export default router;
